import React from 'react';
import { Landmark } from 'lucide-react';
import ModulePageLayout, { Section } from '../../components/ModulePageLayout';
import { getModule } from '../../data/modules';

export default function YieldVaultPage() {
  const module = getModule('yield-vault')!;
  return (
    <ModulePageLayout module={module} Icon={Landmark}>
      <Section title="Yield, Backed by Real-World Assets">
        <p className="text-gray-700 leading-relaxed">
          RWA Yield Vault pools properties and other real-world assets into REIT-style vault structures.
          Investors deposit capital and receive proportional yield distributions based on actual asset
          performance — rental income, appreciation, and more — rather than speculative returns.
        </p>
      </Section>

      <Section title="Choose Your Risk Profile">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
          <div className="border border-gray-200 rounded-xl p-5">
            <h3 className="font-bold text-gray-900 mb-2">Conservative</h3>
            <p className="text-gray-600 text-sm">Stable, established assets. Lower volatility, lower yield ceiling.</p>
          </div>
          <div className="border-2 border-lime-500 rounded-xl p-5">
            <h3 className="font-bold text-gray-900 mb-2">Balanced</h3>
            <p className="text-gray-600 text-sm">A mix of stability and growth-stage assets for moderate risk and return.</p>
          </div>
          <div className="border border-gray-200 rounded-xl p-5">
            <h3 className="font-bold text-gray-900 mb-2">Aggressive</h3>
            <p className="text-gray-600 text-sm">Development-stage assets with higher potential yield and higher risk.</p>
          </div>
        </div>
      </Section>

      <Section title="Getting Paid">
        <p className="text-gray-700 leading-relaxed">
          Vault participants receive regular yield distributions in proportion to their share of the vault —
          no manual claiming process, no guesswork about what you're entitled to.
        </p>
      </Section>
    </ModulePageLayout>
  );
}
